"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7979],{

/***/ 99433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14759);

/* harmony default export */ __webpack_exports__["Z"] = ({
    poster: "/static/img/tags/video_image.png",
    videoId: "l-7awVpecvU",
    fitToParent: false,
    playButtonColor: "iris",
    playButtonSize: _constants__WEBPACK_IMPORTED_MODULE_0__.MD,
    showShadow: true
});


/***/ }),

/***/ 86199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ youtube_video_with_poster_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.scss.js


var StyledYoutubeVideoWithPosterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yvzfjg0"
})("display:flex;flex-direction:column;align-items:center;position:relative;cursor:pointer;.poster-image-wrapper{top:0;left:0;transition:opacity 0.1s ease-out;opacity:1;&.with-shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}img{width:100%;height:100%;object-fit:cover;}}.video-component-wrapper{opacity:0;iframe{display:block;}}&:hover{.play-button-container{transform:translate(-50%,-50%) scale(1.1);}}.play-button-container{border:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:80px;height:80px;border-radius:50%;background-color:", colors/* default.white */.Z.white, ";box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);pointer-events:none;transition:transform 0.2s ease-in-out;.play-button{box-sizing:border-box;border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-left-color:rgb(51,51,51);border-style:solid;border-width:16px 0 16px 28px;position:absolute;left:calc(50% + 4px);top:50%;transform:translate(-50%,-50%);}&.lg{width:128px;height:128px;.play-button{border-width:24px 0 24px 36px;left:calc(50% + 8px);}}}&.hide-poster{.poster-image-wrapper{opacity:0;z-index:-1;}.video-component-wrapper{opacity:1;z-index:1;}}");

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/constants.js
var constants = __webpack_require__(14759);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/default-props.js
var default_props = __webpack_require__(99433);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var YOUTUBE_ASPECT_RATIO = 9 / 16;
var YoutubeVideoWithPosterComponent = function(props) {
    var ref = (0,react.useState)(true), isPosterVisible = ref[0], setIsPosterVisible = ref[1];
    var ref1 = (0,react.useState)(false), playVideo = ref1[0], setPlayVideo = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var width = props.width, fitToParent = props.fitToParent, playButtonColor = props.playButtonColor, poster = props.poster, previewRenderer = props.previewRenderer, alt = props.alt, playButtonSize = props.playButtonSize, translate = props.translate, showShadow = props.showShadow, videoId = props.videoId, muted = props.muted, volume = props.volume, videoOpts = props.videoOpts;
    var onPlayButtonClicked = function(e) {
        setIsPosterVisible(false);
        setPlayVideo(true);
    };
    var getInlineStyle = function() {
        var _ref_current;
        var styleWidth = (_ref_current = ref2.current) === null || _ref_current === void 0 ? void 0 : _ref_current.offsetWidth;
        if (fitToParent && styleWidth) {
            return {
                width: styleWidth,
                height: styleWidth * YOUTUBE_ASPECT_RATIO
            };
        }
        return {
            height: "auto",
            width: width
        };
    };
    var getButtonContainerStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            backgroundColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.color
        };
    };
    var getButtonArrowStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            borderLeftColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.background
        };
    };
    var renderPreview = function() {
        if (previewRenderer) {
            return isPosterVisible && previewRenderer();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("poster-image-wrapper", {
                "with-shadow": showShadow
            }),
            style: {
                display: isPosterVisible ? "block" : "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("play-button-container", playButtonSize),
                    style: getButtonContainerStyle(),
                    "aria-label": translate("accessibility.button.playVideo"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "play-button",
                        style: getButtonArrowStyle()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    pictureClass: "poster-image",
                    alt: alt,
                    src: poster,
                    screenRatios: {
                        mobile: 0.99,
                        mobileRetina: 0.99
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledYoutubeVideoWithPosterComponent, {
        className: classnames_default()("youtube-video-with-poster-component", {
            "hide-poster": !isPosterVisible
        }),
        onClick: onPlayButtonClicked,
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-component-wrapper",
                style: {
                    display: isPosterVisible ? "none" : "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, {
                    videoId: videoId,
                    playing: playVideo,
                    muted: muted,
                    volume: volume,
                    opts: _object_spread({}, getInlineStyle(), videoOpts),
                    showShadow: showShadow
                })
            }),
            renderPreview()
        ]
    });
};
/* harmony default export */ var youtube_video_with_poster_component = ((0,generic_config_context/* withGenericConfig */.P)(YoutubeVideoWithPosterComponent));
YoutubeVideoWithPosterComponent.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 17979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TestimonialsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-info/person-info.scss.js


var StyledPersonInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efrovxz0"
})("display:flex;padding-top:30px;.avatar-image{height:60px;}.person-text{.person{font-weight:400;color:", colors/* default.text-blue */.Z["text-blue"], ";}.person-name{font-weight:700;}font-size:0.875rem;height:60px;display:flex;padding-left:18px;flex-direction:column;justify-content:center;line-height:1.6;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/person-info/default-props.js
/* harmony default export */ var default_props = ({
    personImg: {
        src: "/static/img/templates-generator/joel.png"
    },
    name: "Paul Chapman",
    jobDescription: "Chief Executive & Founder",
    personPhotoborderRadius: "50px"
});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/core-components/person-info/person-info.js









var PersonInfo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PersonInfo, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PersonInfo);
    function PersonInfo() {
        (0,_class_call_check/* default */.Z)(this, PersonInfo);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PersonInfo, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, personImg = _props.personImg, name = _props.name, jobDescription = _props.jobDescription, personPhotoborderRadius = _props.personPhotoborderRadius;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPersonInfo, {
                    className: "person-info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "avatar-image",
                            src: personImg.src,
                            alt: personImg.alt,
                            specificImageStyle: {
                                borderRadius: personPhotoborderRadius
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "person-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "person-name person",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "job-description person",
                                    children: jobDescription
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return PersonInfo;
}(react.PureComponent);

PersonInfo.defaultProps = default_props;

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonials-quote/testimonials-quote.scss.js




var QUOTE = "/static/img/segments/icons/quote.png";
var StyledTestimonialsQuote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exd5vp50"
})(".testimonials-text{z-index:1;line-height:38px;position:relative;}margin-top:40px;font-size:1.375rem;line-height:40px;color:", colors/* default.text-grey */.Z["text-grey"], ";position:relative;.quote-background{background-image:url(", (0,cloudinary_service.generateCloudinaryImageUrl)(QUOTE), ");background-repeat:no-repeat,no-repeat;width:100px;height:100px;background-size:contain,auto;position:absolute;left:-36px;top:0;z-index:0;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.quote-background{left:16px !important;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonials-quote/default-props.js
/* harmony default export */ var testimonials_quote_default_props = ({
    testimonial: "Our organization is scaling incredibly fast. The monday.com platform has kept up with our needs, flexing to fill in the gaps as we continue to grow."
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonials-quote/testimonials-quote.js








var TestimonialsQuote = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TestimonialsQuote, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TestimonialsQuote);
    function TestimonialsQuote(props) {
        (0,_class_call_check/* default */.Z)(this, TestimonialsQuote);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(TestimonialsQuote, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, testimonial = _props.testimonial, removeQuote = _props.removeQuote, quoteFontSize = _props.quoteFontSize, quoteLineHeight = _props.quoteLineHeight;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTestimonialsQuote, {
                    className: "testimonials-quote",
                    children: [
                        !removeQuote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "quote-background"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "testimonials-text",
                            style: {
                                fontSize: quoteFontSize,
                                lineHeight: quoteLineHeight
                            },
                            children: testimonial
                        })
                    ]
                });
            }
        }
    ]);
    return TestimonialsQuote;
}(react.PureComponent);

TestimonialsQuote.defaultProps = testimonials_quote_default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-testimonials-quote/full-testimonials-quote.scss.js


var StyledFullTestimonialsQuote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ivkqzp0"
})("word-break:break-word;max-width:640px;margin:0 auto;.full-testimonials-title{letter-spacing:-0.5px;color:", colors/* default.tuna */.Z.tuna, ";.full-testimonials-dot{line-height:0px;font-size:3.263rem;}}");

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-testimonials-quote/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var full_testimonials_quote_default_props = (_object_spread({
    title: "Enjoy working in a platform that adapts to your needs<monday-dot pink />",
    titleSize: sizes.MD
}, default_props, testimonials_quote_default_props));

;// CONCATENATED MODULE: ./segments/desktop/core-components/full-testimonials-quote/full-testimonials-quote.js




function full_testimonials_quote_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_testimonials_quote_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_testimonials_quote_define_property(target, key, source[key]);
        });
    }
    return target;
}







var FullTestimonialsQuote = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullTestimonialsQuote, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullTestimonialsQuote);
    function FullTestimonialsQuote() {
        (0,_class_call_check/* default */.Z)(this, FullTestimonialsQuote);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullTestimonialsQuote, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, testimonialsConfig = _props.testimonialsConfig, personConfig = _props.personConfig, title = _props.title, titleSize = _props.titleSize, maxWidth = _props.maxWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFullTestimonialsQuote, {
                    className: "full-testimonials-quote",
                    style: {
                        maxWidth: maxWidth
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "full-testimonials-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                                title: title,
                                titleSize: titleSize
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsQuote, full_testimonials_quote_object_spread({}, testimonialsConfig)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonInfo, full_testimonials_quote_object_spread({}, personConfig))
                    ]
                });
            }
        }
    ]);
    return FullTestimonialsQuote;
}(react.PureComponent);

FullTestimonialsQuote.defaultProps = full_testimonials_quote_default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./constants/cloudinary-asset-qualities.js
var cloudinary_asset_qualities = __webpack_require__(65832);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js + 1 modules
var youtube_video_with_poster_component = __webpack_require__(86199);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-component.scss.js

var StyledTestimonialsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19tgl3m0"
})(".image-wrapper{height:100%;.youtube-video-with-poster-component{display:flex;justify-content:center;aspect-ratio:100/56.25;width:100%;.video-component-wrapper{height:100%;width:100%;min-width:300px;& *{height:100%;width:100%;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-component.js






function testimonials_text_and_asset_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonials_text_and_asset_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonials_text_and_asset_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var TestimonialsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TestimonialsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TestimonialsTextAndAssetComponent);
    function TestimonialsTextAndAssetComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, TestimonialsTextAndAssetComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        testimonials_text_and_asset_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getProps", function() {
            var _this_props = _this.props, youtubeWithPosterProps = _this_props.youtubeWithPosterProps, rest = _object_without_properties(_this_props, [
                "youtubeWithPosterProps"
            ]);
            if (youtubeWithPosterProps === null || youtubeWithPosterProps === void 0 ? void 0 : youtubeWithPosterProps.videoId) {
                return testimonials_text_and_asset_component_object_spread({
                    replaceAssetComponent: youtube_video_with_poster_component/* default */.Z,
                    replaceAssetComponentProps: youtubeWithPosterProps
                }, rest);
            }
            return _this.props;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(TestimonialsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTestimonialsTextAndAssetComponent, {
                    className: "testimonials-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, testimonials_text_and_asset_component_object_spread({
                        replaceTextComponent: FullTestimonialsQuote
                    }, this.getProps()))
                });
            }
        }
    ]);
    return TestimonialsTextAndAssetComponent;
}(react.PureComponent);

TestimonialsTextAndAssetComponent.defaultProps = {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: cloudinary_asset_qualities.AUTO,
    fullParagraph: testimonials_text_and_asset_component_object_spread({}, FullTestimonialsQuote.defaultProps)
};


/***/ })

}]);